module.exports = __webpack_public_path__ + "img/upload_bg_02.92c41334.png";